import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { TracksListProvider } from './stores/TracksListProvider'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <TracksListProvider>
      <App/>
    </TracksListProvider>
  </StrictMode>,
)